import React, { useState, useEffect } from 'react';
import './SelfieWidget.css';

/**
 * @param status - {boolean}
 * @param onCLoseCallback - {function}
 * @returns {JSX.Element}
 */
const SelfieWidget = ({ status }) => {
    const [initialized, setInitialized] = useState(false);
    let script = null;

    //State Status update
    useEffect(() => {
        //initialize only when requested to open at first time
        if (status && !initialized) initialize();
        triggerCamera();
    }, [status]);

    const initialize = () => {
        setInitialized(true);
        //Attach script
        script = document.createElement('script');
        script.id = 'selfieScript';
        script.src = 'https://widgets.obsess-vr.com/selfie-app/test/selfie-widget-library.min.js';
        script.setAttribute('data-useTensorflowRemoveBackground', 'false');
        script.defer = true;
        document.body.appendChild(script);
    };

    const triggerCamera = () => {
        var interval;
        interval = setInterval(() => {
            const selfieBtn = document.getElementsByClassName("takeSelfieIcon")
            if (selfieBtn.length > 0) {
                document.getElementsByClassName("takeSelfieIcon")[0].style.display = 'none'
                clearInterval(interval)
                selfieBtn[0].getElementsByClassName("pointerIcon")[0].click()
                updateWidgetCss()
            }
        }, 100);
    };

    const updateWidgetCss = () => {
        var interval;
        // interval = setInterval(() => {
        //     const selfieWidget = document.getElementById("selfieWidget")
        //     if (selfieWidget) {
        //         selfieWidget.setAttribute('style', 'top: 65% !important;');
        //         clearInterval(interval)
        //     }
        // }, 100);
    };

    if (initialized) {
        return (
            <div id="selfieWidget" className={status ? 'active' : ''}>
                <div id="selfie-root"></div>
            </div>
        );
    } else {
        return false;
    }
}
export default SelfieWidget;
